import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { compareAsc, format, addMonths, isValid } from "date-fns";
import $ from "jquery";

const statusOptions = [
  "Open",
  "Selected",
  "Offer Released",
  "Offer Accepted",
  "Joined",
  "Rejected",
  "On Hold",
];

const HiringTeamForm = ({ onSuccess }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const requestId = queryParams.get("id");

  console.log("Request ID:", requestId);

  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));
  const tokenDecoded = jwt_decode(token.value);
  let fname = tokenDecoded.fname ?? "";
  let lname = tokenDecoded.lname ?? "";
  let recruiterName = fname + " " + lname ?? "";

  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    status: "Open",
    recruiter: "",
    comp_id: "",
    project_id: "",
    vertical: "",
    department: "",
    department_text: "",
    client_name: "",
    skills: "",
    sourcing_mode: "",
    experience: "",
    candidate_name: "",
    contact: "",
    personal_email: "",
    email: "",
    employee_code: "",
    system_role: "",
    address: "",
    noticeperiod: "",
    probation_period: "",
    hr_confirmationdate: "",
    unit: "",
    rates: "",
    offered_date: "",
    offered_amount_monthly: "",
    bonus: "",
    date_of_joining: "",
    mode_of_employment: "",
    mode_of_employment_text: "",
    contract_duration: "",
    location_final: "",
    remarks: "",
    created_by: "",
    updated_by: "",
  });

  useEffect(() => {
    if (requestId) {
      fetchRequest();
    }
  }, [requestId]);

  const fetchRequest = async () => {
    try {
      const response = await fetch(
        `${SERVER_URL}api/HiringTeam/hiring-team/${requestId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token?.value}`,
          },
        },
      );
      // const response = await fetch(
      //   `${SERVER_URL}/requestTeam/request/${requestId}`,
      // );

      const result = await response.json();
      console.log(result, "request=============");
      if (result.success) {
        setRequest(result.request);

        if (result.candidate) {
          setFormData({
            status: result.candidate.status || "Open",
            comp_id: result.request.comp_id || "",
            project_id: result.request.project_id || "",
            vertical: result.request.vertical || "",
            department: result.request.department || "",
            skills: result.request.skills || "",
            recruiter: result.candidate.recruiter || recruiterName,
            sourcing_mode: result.candidate.sourcing_mode || "",
            experience: result.candidate.experience || "",
            candidate_name: result.candidate.candidate_name || "",
            contact: result.candidate.contact || "",
            personal_email: result.candidate.personal_email || "",
            email: result.candidate.email || "",
            address: result.candidate.address || "",
            employee_code: result.candidate.employee_code || "",
            system_role: result.candidate.system_role || "",
            hr_confirmationdate: result.candidate.hr_confirmationdate
              ? result.candidate.hr_confirmationdate.substring(0, 10)
              : "",
            probation_period: result.candidate.probation_period || "",
            noticeperiod: result.candidate.noticeperiod || "",
            unit: result.candidate.unit || "",
            rates: result.candidate.rate || "",
            offered_date: result.candidate.offered_date
              ? result.candidate.offered_date.substring(0, 10)
              : "",

            offered_amount_monthly:
              result.candidate.offered_amount_monthly || "",

            bonus: result.candidate.bonus || "",

            date_of_joining: result.candidate.date_of_joining
              ? result.candidate.date_of_joining.substring(0, 10)
              : "",

            mode_of_employment: result.candidate.mode_of_employment || "",

            contract_duration: result.candidate.contract_duration || "",

            location_final: result.candidate.location_final || "",

            remarks: result.candidate.remarks || "",
            updated_by: tokenDecoded.userId,
            created_by: result.request.created_by,
          });
        }
      }
    } catch (error) {
      console.error("Fetch request error:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Get selected option text
    const selectedText = e.target.options?.[e.target.selectedIndex]?.text || "";
    //alert(selectedText);
    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [name]: value,
      };

      // ==========================================
      // MODE OF EMPLOYMENT CHANGED
      // ==========================================
      if (name === "mode_of_employment") {
        updatedData.mode_of_employment_text = selectedText;
        // Full Time / Employee
        if (String(value) === "1") {
          updatedData.probation_period = "6";
          updatedData.noticeperiod = "15";
        }

        // Contract
        if (String(value) === "2") {
          updatedData.noticeperiod = "7";
          updatedData.probation_period = prev.contract_duration || "";
        }
      }

      // ==========================================
      // CONTRACT DURATION CHANGED
      // ==========================================
      if (
        name === "contract_duration" &&
        String(prev.mode_of_employment) === "2"
      ) {
        updatedData.probation_period = value;
      }

      return updatedData;
    });
  };

  const calculateAnnualAmount = () => {
    const monthly = Number(formData.offered_amount_monthly || 0);
    const bonus = Number(formData.bonus || 0);

    return monthly * 12 + bonus;
  };

  const calculateContractEndDate = () => {
    if (!formData.date_of_joining || !formData.contract_duration) {
      return "";
    }

    const date = new Date(formData.date_of_joining);

    date.setMonth(date.getMonth() + Number(formData.contract_duration));

    return date.toISOString().split("T")[0];
  };

  const calculateAgingDays = () => {
    if (!request?.position_open_date) {
      return 0;
    }

    const start = new Date(request.position_open_date);
    const today = new Date();

    const difference = today - start;

    return Math.max(0, Math.floor(difference / (1000 * 60 * 60 * 24)));
  };

  const getAgingRange = (days) => {
    if (days <= 7) return "0-7 Days";
    if (days <= 15) return "8-15 Days";
    if (days <= 30) return "16-30 Days";
    if (days <= 60) return "31-60 Days";

    return "60+ Days";
  };
  const calculateConfirmationDate = () => {
    if (!formData.date_of_joining || !formData.probation_period) {
      return "";
    }

    const date = new Date(formData.date_of_joining);

    date.setMonth(date.getMonth() + Number(formData.probation_period));

    return date.toISOString().split("T")[0];
  };
  const formatDateInWords = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString + "T00:00:00");
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    const suffix =
      day % 100 >= 11 && day % 100 <= 13
        ? "th"
        : day % 10 === 1
          ? "st"
          : day % 10 === 2
            ? "nd"
            : day % 10 === 3
              ? "rd"
              : "th";

    return `${day}${suffix} day of ${month} ${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.status) {
      alert("Please select status");
      return;
    }

    if (
      formData.status === "Selected" ||
      formData.status === "Offer Released" ||
      formData.status === "Offer Accepted" ||
      formData.status === "Joined"
    ) {
      if (!formData.sourcing_mode) {
        alert("Candidate Source is required");
        return;
      }
      if (!formData.experience) {
        alert("Candidate experience is required");
        return;
      }
      if (!formData.candidate_name) {
        alert("Candidate name is required");
        return;
      }

      if (!formData.personal_email) {
        alert("Candidate Personal email is required");
        return;
      }
      if (!formData.address) {
        alert("Candidate Address is required");
        return;
      }
    }
    // =====================================================
    // JOINED VALIDATION
    // =====================================================
    if (formData.status === "Joined") {
      if (!formData.email?.trim()) {
        alert("Office email is required");
        return;
      }

      if (!formData.employee_code?.trim()) {
        alert("Employee Code is required");
        return;
      }

      if (!formData.system_role) {
        alert("Employee System role is required");
        return;
      }
      if (!formData.address) {
        alert("Candidate Address is required");
        return;
      }
      if (!formData.mode_of_employment) {
        alert("Mode of Employment is required");
        return;
      }

      if (!formData.offered_date) {
        alert("Offered date is required");
        return;
      }

      if (!formData.date_of_joining) {
        alert("Joining date is required");
        return;
      }
    }

    try {
      setLoading(true);
      const date = new Date();
      const date_formate = format(date, "yyyy-MM-dd HH:m:ss");
      const userId = localStorage.getItem("userId");
      const agingDays = calculateAgingDays();

      const payload = {
        ...formData,

        request_id: requestId,

        aging_days: agingDays,
        aging_range: getAgingRange(agingDays),
        // Hidden values
        hidden_comp_id: formData.comp_id,
        hidden_project_id: formData.project_id,
        hidden_dept_id: formData.department,
        hidden_division_id: formData.vertical,
        system_role: formData.system_role,
        created_by: formData.created_by,
        updated_by: userId,
        created_at: date_formate,
        unit: formData.unit,
        rates: formData.rates,
        department_text: request.vartical_name,
        client_name: request.client_name,
        hr_confirmationdate: formData.hr_confirmationdate,
        mode_of_employment_text: formData.mode_of_employment_text,
        date_of_joining_formatted: formatDateInWords(formData.date_of_joining),
        offered_month: formData.offered_date
          ? new Date(formData.offered_date).toLocaleString("en-US", {
              month: "long",
            })
          : "",

        offered_amount_annually: calculateAnnualAmount(),

        joining_month: formData.date_of_joining
          ? new Date(formData.date_of_joining).toLocaleString("en-US", {
              month: "long",
            })
          : "",

        contract_ending_date: calculateContractEndDate(),
      };
      console.log(payload, "payload submitted===============stage");
      const response = await fetch(
        `${SERVER_URL}api/HiringTeam/hiring-team-candidate`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token?.value}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || "Unable to save hiring information");
      }

      alert(result.message);

      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      console.error("Save hiring error:", error);
      alert(error.message || "Unable to save hiring information");
    } finally {
      setLoading(false);
    }
  };

  const annualAmount = calculateAnnualAmount();
  const contractEndDate = calculateContractEndDate();
  const agingDays = calculateAgingDays();

  return (
    <>
      <div className="page-header">
        <h1>Hiring Request</h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>Hiring Form{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Hiring Employee
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="dash_white_box2">
          <div className="row mb30">
            {/* REQUEST INFORMATION */}
            <h5 className="mb-3">Request Information</h5>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>Request ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={request?.id || requestId}
                  disabled
                />
              </div>

              <div className="col-md-3 mb-3">
                <label>Profile Details</label>
                <input
                  type="text"
                  className="form-control"
                  value={request?.profile_details || ""}
                  disabled
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Company</label>
                <input
                  type="text"
                  className="form-control"
                  value={request?.client_name || ""}
                  disabled
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Project Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={request?.project_name || ""}
                  disabled
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Vertical</label>
                <input
                  type="text"
                  className="form-control"
                  value={request?.vartical_name || ""}
                  disabled
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Department</label>
                <input
                  type="text"
                  className="form-control"
                  value={request?.dept_name || ""}
                  disabled
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Skills</label>
                <input
                  type="text"
                  className="form-control"
                  value={request?.skills || ""}
                  disabled
                />
              </div>

              <div className="col-md-3 mb-3">
                <label>Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={request?.location || ""}
                  disabled
                />
              </div>
            </div>
            <hr />
            {/* RECRUITMENT */}
            <h5 className="mb-3">Recruitment Information</h5>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>
                  Status <span className="text-danger">*</span>
                </label>

                <select
                  name="status"
                  className="form-control"
                  value={formData.status}
                  onChange={handleChange}
                >
                  {statusOptions.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 mb-3">
                <label>Aging Days</label>

                <input
                  type="text"
                  className="form-control"
                  value={agingDays}
                  disabled
                />
              </div>

              <div className="col-md-3 mb-3">
                <label>Aging Range</label>

                <input
                  type="text"
                  className="form-control"
                  value={getAgingRange(agingDays)}
                  disabled
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>
                  Recruiter <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  name="recruiter"
                  className="form-control"
                  value={formData.recruiter}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>Sourcing Mode</label>

                <select
                  name="sourcing_mode"
                  className="form-control"
                  value={formData.sourcing_mode}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="LinkedIn">LinkedIn</option>
                  <option value="Naukri">Naukri</option>
                  <option value="Referral">Referral</option>
                  <option value="Consultancy">Consultancy</option>
                  <option value="Internal">Internal</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="col-md-3 mb-3">
                <label>Candidate Experience</label>

                <input
                  type="number"
                  step="0.1"
                  name="experience"
                  className="form-control"
                  value={formData.experience}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3 mb-3">
                <label>
                  Candidate Name <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  name="candidate_name"
                  className="form-control"
                  value={formData.candidate_name}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3 mb-3">
                <label>Contact</label>

                <input
                  type="text"
                  name="contact"
                  className="form-control"
                  value={formData.contact}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>
                  Personal Email ID <span className="text-danger">*</span>
                </label>

                <input
                  type="email"
                  name="personal_email"
                  className="form-control"
                  value={formData.personal_email}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>
                  Office Email ID <span className="text-danger">*</span>
                </label>

                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              {formData.status === "Joined" && (
                <div className="col-md-3 mb-3">
                  <label>
                    Employee Code <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    name="employee_code"
                    id="employee_code"
                    className="form-control"
                    value={formData.employee_code || ""}
                    onChange={handleChange}
                    placeholder="Enter employee code"
                  />
                </div>
              )}
              <div className="col-md-3 mb-3">
                <label>
                  System Role <span className="text-danger">*</span>
                </label>

                <select
                  name="system_role"
                  id="system_role"
                  className="form-control"
                  value={formData.system_role}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="1">Employee</option>
                  <option value="2">HR Executive</option>
                  <option value="3">Manager</option>
                  <option value="4">Senior Executive</option>
                  <option value="5">Executive</option>
                  <option value="6">Leadership</option>
                  <option value="7">Account Manager</option>
                  <option value="8">Project Manager</option>
                  <option value="9">IT Manager</option>
                  <option value="10">Team Lead</option>
                  <option value="11">HOD</option>
                  <option value="12">Production Manager</option>
                  <option value="13">Editorial Manager</option>
                  <option value="14">Art Director</option>
                  <option value="15">Quality Manager</option>
                  <option value="16">Business Finance Manager</option>
                  <option value="17">Accounts Receivable Manager</option>
                  <option value="18">Accounts Payable Manager</option>
                  <option value="19">Compliance Manager</option>
                  <option value="20">Reviewer</option>
                  <option value="21">Process Head</option>
                  <option value="22">Pre-Sales Manager</option>
                  <option value="23">Subject Matter Expert (SME)</option>
                  <option value="24">Content Writer</option>
                  <option value="25">Copy Editor</option>
                  <option value="26">Proofreader</option>
                  <option value="27">Fact Checker</option>
                  <option value="28">Admin Manager</option>
                  <option value="29">Rights &amp; Permissions Manager</option>
                  <option value="30">Inter</option>
                  <option value="31">Trainee</option>
                  <option value="32">Front End Developer</option>
                  <option value="33">Backend Developer</option>
                  <option value="34">Full Stack Developer</option>
                  <option value="35">UI Developer</option>
                  <option value="36">UI Designer</option>
                  <option value="37">Designer</option>
                  <option value="38">Line Artist</option>
                  <option value="39">Colour Artist</option>
                  <option value="40">Assistant Production Manager</option>
                  <option value="41">Quality Control</option>
                  <option value="42">Business Finance Analyst</option>
                </select>
              </div>
              <div className="col-md-12 mb-3">
                <label>Employee Address</label>

                <textarea
                  name="address"
                  className="form-control"
                  rows="3"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
            </div>
            <hr />
            {/* OFFER */}
            <h5 className="mb-3">Offer Information</h5>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>
                  Mode of Employment <span className="text-danger">*</span>
                </label>

                <select
                  name="mode_of_employment"
                  id="mode_of_employment"
                  className="form-control"
                  value={formData.mode_of_employment}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="1">Full Time</option>
                  <option value="2">Contract</option>
                </select>
              </div>
              <div className="col-md-3 mb-3">
                <label>
                  Offered Date <span className="text-danger">*</span>
                </label>

                <input
                  type="date"
                  name="offered_date"
                  id="offered_date"
                  className="form-control"
                  value={formData.offered_date}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Contract Ending Date</label>

                <input
                  type="date"
                  className="form-control"
                  value={contractEndDate}
                  disabled
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>
                  Contract Duration (Months){" "}
                  <span className="text-danger">*</span>
                </label>

                <input
                  type="number"
                  name="contract_duration"
                  id="contract_duration"
                  className="form-control"
                  value={formData.contract_duration}
                  onChange={handleChange}
                />
              </div>
            </div>
            {formData.mode_of_employment === "1" && (
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label>Monthly Offered Amount</label>

                  <input
                    type="number"
                    name="offered_amount_monthly"
                    id="offered_amount_monthly"
                    className="form-control"
                    value={formData.offered_amount_monthly}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-3 mb-3">
                  <label>Bonus</label>

                  <input
                    type="number"
                    name="bonus"
                    className="form-control"
                    value={formData.bonus}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-3 mb-3">
                  <label>Annual Offered Amount</label>

                  <input
                    type="number"
                    className="form-control"
                    value={annualAmount}
                    disabled
                  />
                </div>
              </div>
            )}
            ;
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>
                  Unit <span className="text-danger">*</span>
                </label>

                <select
                  name="unit"
                  id="unit"
                  className="form-control"
                  value={formData.unit}
                  onChange={handleChange}
                >
                  <option value="">Select unit </option>
                  <option value="Per Game">Per Game</option>
                  <option value="Per Grade">Per Grade</option>
                  <option value="Per Hour">Per Hour</option>
                  <option value="Per Image">Per Image</option>
                  <option value="Per Item">Per Item</option>
                  <option value="Per Lesson">Per Lesson</option>
                  <option value="Per Page">Per Page</option>
                  <option value="Per Paragraph">Per Paragraph</option>
                  <option value="Per Question">Per Question</option>
                  <option value="Per SCO">Per SCO</option>
                  <option value="Per Set">Per Set</option>
                  <option value="Per Unit">Per Unit</option>
                  <option value="Per Workshop">Per Workshop</option>
                </select>
              </div>
              <div className="col-md-3 mb-3">
                <label>
                  Rates <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  name="rates"
                  id="rates"
                  className="form-control"
                  value={formData.rates}
                  onChange={handleChange}
                />
              </div>
            </div>
            <hr />
            {/* JOINING */}
            <h5 className="mb-3">Joining Information </h5>
            <div className="row">
              <div className="col-md-3 mb-3">
                <label>
                  Date of Joining <span className="text-danger">*</span>
                </label>

                <input
                  type="date"
                  name="date_of_joining"
                  id="date_of_joining"
                  className="form-control"
                  value={formData.date_of_joining}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>
                  Confirmation Date <span className="text-danger">*</span>
                </label>

                <input
                  type="date"
                  name="hr_confirmationdate"
                  id="hr_confirmationdate"
                  className="form-control"
                  value={formData.hr_confirmationdate}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Probation Period (Month)</label>

                <input
                  type="text"
                  name="probation_period"
                  id="probation_period"
                  className="form-control"
                  value={formData.probation_period}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Notice Period (Days)</label>

                <input
                  type="text"
                  name="noticeperiod"
                  id="notice_period"
                  className="form-control"
                  value={formData.noticeperiod}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mb-3">
                <label>Work Location</label>

                <select
                  name="location_final"
                  id="location_final"
                  className="form-control"
                  value={formData.location_final}
                  onChange={handleChange}
                >
                  <option value="">Select </option>
                  <option value="1">Noida </option>
                </select>
              </div>

              <div className="col-md-3 mb-3">
                <label>Joining Month</label>

                <input
                  type="text"
                  className="form-control"
                  value={
                    formData.date_of_joining
                      ? new Date(formData.date_of_joining).toLocaleString(
                          "en-US",
                          {
                            month: "long",
                          },
                        )
                      : ""
                  }
                  disabled
                />
              </div>

              <div className="col-md-12 mb-3">
                <label>Remarks</label>

                <textarea
                  name="remarks"
                  className="form-control"
                  rows="3"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </div>
            </div>
            <button
              type="button"
              className="btn btn-primary"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? "Saving..." : "Save Hiring Details"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default HiringTeamForm;
